import React, { useState, useEffect } from 'react'
import { getUserDetails, clearAllData } from '../Utility/AsyncStorage';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showToast } from './Toast';
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { FaClock, FaPauseCircle, FaPowerOff } from "react-icons/fa";
import '../Styles/MachineIncharge.css'
import { FaUserCircle, FaTimes } from 'react-icons/fa';
import Loader from './Loader';



const MachineStatusCard = (machineData) => {
    const navigate = useNavigate();
    // console.log(machineData)
    machineData = machineData.data

    if (!machineData) {
        return <h1> Loding... </h1>
    }

    const timeToMinutes = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(":").map(Number);
        return hours * 60 + minutes + Math.floor(seconds / 60);
    };

    const formatTime = (totalMinutes) => {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        const seconds = 0; // Assuming we ignore precise seconds

        return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    };

    const calculateTotalTime = (active_time, idle_time) => {
        const activeMinutes = timeToMinutes(active_time);
        const idleMinutes = timeToMinutes(idle_time);
        const total = activeMinutes + idleMinutes;
        return formatTime(total);
    }

    const generateGraphData = (active_time, idle_time) => {
        const activeMinutes = timeToMinutes(active_time);
        const idleMinutes = timeToMinutes(idle_time);
        const data = [
            { name: "Run Time", value: activeMinutes },
            { name: "Idle Time", value: idleMinutes },
        ];
        return data;
    };

    return (
        <div className='card-1'>
            {machineData.map((machine, index) => (
                <div className="machine-card" key={index}
                    onClick={() => navigate("/dashboard", { state: machine.machine_id })}>
                    <div className='deviceName'>
                        <h5 style={{ fontWeight: 600, letterSpacing: 2 }}>
                            {machine.device_name == "" ? `Device ${machine.device_id}` : machine.device_name} / {machine.machine_name ?? `Machine ${machine.machine_id}`}
                        </h5> </div>
                    <div className='time-and-graph'>
                        <div className='data-block'>
                            <div className="time-details">
                                <div className="time-box run-time" style={{ width: "49%" }}>
                                    <FaClock className="icon" />
                                    <div>
                                        <p>Run Time</p>
                                        <h3>{machine.active_time} hours</h3>
                                    </div>
                                </div>
                                <div className="time-box idle-time" style={{ width: "49%" }}>
                                    <FaPauseCircle className="icon" />
                                    <div>
                                        <p>Idle Time</p>
                                        <h3>{machine.idle_time} hours</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="time-details">
                                <div className="time-box" style={{ width: "31%", backgroundColor: "#FAE7EB" }}>
                                    <div style={{ width: "100%" }}>
                                        <p style={{ textAlign: 'center' }}>Active Batch</p>
                                        <h3 style={{ textAlign: 'center' }}>{machine.active_batch}</h3>
                                    </div>
                                </div>
                                <div className="time-box" style={{ width: "31%", backgroundColor: "#E0D4E7" }}>
                                    {/* <FaPauseCircle className="icon" /> */}
                                    <div style={{ width: "100%" }}>
                                        <p style={{ textAlign: 'center' }}>Active Blade</p>
                                        <h3 style={{ textAlign: 'center' }}>{machine.active_blade}</h3>
                                    </div>
                                </div>
                                <div className="time-box" style={{ width: "31%", backgroundColor: "#DBEEE7" }}>
                                    {/* <FaPauseCircle className="icon" /> */}
                                    <div style={{ width: "100%", textAlign: 'center' }}>
                                        <p style={{ textAlign: 'center' }}>Blade Life</p>
                                        <h3 style={{ textAlign: 'center' }}>{machine.blade_life}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="chart-container">
                            {/* <ResponsiveContainer > */}
                            <PieChart width={180} height={150}>
                                <Pie data={generateGraphData(machine.active_time, machine.idle_time)} cx="50%" cy="50%" innerRadius={40} outerRadius={60} dataKey="value">
                                    <Cell fill="#2ecc71" />
                                    <Cell fill="#f1c40f" />
                                </Pie>
                            </PieChart>
                            {/* </ResponsiveContainer> */}
                            <div className="chart-center">
                                <h2 style={{ fontSize: 15 }}>{calculateTotalTime(machine.active_time, machine.idle_time)}</h2>
                                <p style={{ fontSize: 15 }}>Total</p>
                            </div>
                        </div>
                    </div>

                    {/* <div className="legend">
          {data.map((item, index) => (
            <div key={index} className="legend-item">
              <span className="color-dot" style={{ backgroundColor: item.color }}></span>
              <p>{item.name} {item.value}</p>
            </div>
          ))}
        </div> */}
                </div>
            ))}

        </div>
    );
};


function MachineIncharge() {
    const userdetails = getUserDetails()
    const navigate = useNavigate();

    const [machineListData, setMachineListData] = useState([])
    const [isHovered, setIsHovered] = useState(false);

    const [loaderState, setLoaderState] = useState(true);

    const handleLogout = async () => {
        // Do your logout logic here
        console.log("Logging out...", userdetails);
        await clearAllData()
        navigate("/")
    };

    const machineList = async () => {
        try {
            let url = "https://itlapi.flovation.in/user/fetchAssignedMachineData";
            let body = {
                user_num: userdetails.user_num
            }
            // machineList.log("PLCData", url, body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userdetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {
                    
                    setLoaderState(false)
                    if (response.data.statusCode === 0) {
                        // console.log("machineList", response.data)
                        setMachineListData(response.data.op)
                    }
                    else {
                        console.log("machineList", response.data.msg)
                    }

                } else {
                    console.log("machineList error")
                }

            }).catch(error => {
                if (error.response.status === 403) {
                    console.log("machineList if", error)
                    showToast("Session Time Out", 3000, "red");
                    navigate("/")
                }
                else {
                    console.log("machineList else", error)
                    showToast("Session Time Out", 3000, "red");
                }

            })
        } catch (error) {
            console.log("machineList", error)
            showToast("Session Time Out", 3000, "red");
        }
    }

    useEffect(() => {
        const fetchData = () => {
            machineList();
        };

        fetchData();

        const interval = setInterval(fetchData, 50000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <div
                className="user-container"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Icon */}
                <div className="user-icon">
                    <FaUserCircle size={28} />
                </div>

                {/* Panel on hover */}
                <div className={`user-panel ${isHovered ? 'open' : ''}`}>
                    <div className="user-info-card">
                        <div className="user-details">
                            <div className="detail-row">
                                <span className="label">👤 </span>
                                <span className="value">{userdetails?.name}</span>
                            </div>
                            <div className="detail-row">
                                <span className="label">📞 </span>
                                <span className="value">{userdetails?.phone}</span>
                            </div>
                        </div>
                    </div>

                    <button className="logout-btn" onClick={handleLogout}>Logout</button>
                </div>
            </div>

            <div className="navbar" style={{
                display: 'inline-flex', flexDirection: "row", alignItems: "center", backgroundColor: 'white', width: "100%",
                //     position: "fixed", zIndex: 2, 
                // boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)"
            }}>
                <div className='comp-name' style={{ marginLeft: 30 }}>
                    <img style={{ width: "60px", marginRight: 10 }}
                        src={require("../Assets/T_LOGO_1.jpg")}
                        alt="logo"
                    />
                    <div>
                        <h2 className="dashboard-header-h2"> ITL Industries Ltd.</h2>
                        <h5 className='dashboard-header-h5'>(a BSE Listed, ISO 9001:2015 Certified Company)</h5>
                    </div>
                </div>
            </div>
            <div style={{ height: "85vh" }}>
                {/* <h3>User Details</h3>
                <ul>
                    {Object.entries(userdetails).map(([key, value]) => (
                        <li key={key}>
                            <strong>{key}:</strong> {value}
                        </li>
                    ))}
                </ul> */}

                {loaderState ? (
                    <Loader />
                ) : machineListData.length === 0 ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
                        <img
                            src={require("../Assets/no_data.png")}
                            alt="No Data"
                            style={{
                                borderRadius: 20,
                                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
                            }}
                        />
                    </div>
                ) : (
                    <div style={{ padding: "20px" }}>
                        <MachineStatusCard data={machineListData} />
                    </div>
                )}

            </div>

            <div className='powered'>
                <i class="fa fa-copyright" style={{ fontSize: 10 }}></i>
                <p >Powered by</p>
                <img style={{ width: "20px", margin: "0  0 0 5px" }}
                    src={require("../Assets/new_logo.png")}
                    alt="logo"
                />
                <p style={{ margin: 0, fontWeight: 600 }}>SuperManager</p>
            </div>
        </div>
    )
}

export default MachineIncharge